import { render, staticRenderFns } from "./alipayForm.vue?vue&type=template&id=b2779c66&scoped=true&"
import script from "./alipayForm.vue?vue&type=script&lang=js&"
export * from "./alipayForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2779c66",
  null
  
)

export default component.exports